import { render, staticRenderFns } from "./MetabaseWidget.vue?vue&type=template&id=50c697e9&scoped=true&"
import script from "./MetabaseWidget.vue?vue&type=script&lang=js&"
export * from "./MetabaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseWidget.vue?vue&type=style&index=0&id=50c697e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c697e9",
  null
  
)

export default component.exports